"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

var useLink = function useLink() {
  var REACT_APP_SPA = process.env.REACT_APP_SPA;

  var _navigate = (0, _reactRouterDom.useNavigate)();

  var navigate = (0, _react.useCallback)(function (to) {
    if (REACT_APP_SPA === "true") {
      _navigate(to);

      return;
    }

    var url = window.location.pathname + window.location.search + window.location.hash;
    if (to === url) return;
    window.location.href = to;
  }, [REACT_APP_SPA, _navigate]);
  return navigate;
};

var _default = useLink;
exports.default = _default;